// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"a989eaa9","787":"3661ae7a"}[chunkId] + ".chunk.js";
};